// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2eK2j_y0qt2pwAmNIDs_7D","text":"eZTfaY1oPt4EsUMmrKcGi","cta":"_-7C2FCPYWmxbzolV_jw1y"};